var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seasidetms_color_scheme_footer",attrs:{"id":"bottom"}},[_c('div',{staticClass:"bottom_bg"},[_c('div',{staticClass:"bottom_outer"},[_c('div',{staticClass:"bottom_inner sidebar_layout_14141414"},[_c('FooterCategoriesMenu'),_c('FooterMainMenu'),_c('FooterInfoMenu'),_c('NetpeakFooter')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }